import ProductCollectCard from './ProductCollectCard';

export default ProductCollectCard;
